import {GridItem, HStack} from '@chakra-ui/react';
import {State} from '@synako/halitrek';
import {ClientDesc, LivraisonDesc} from 'api-types/ffconnect-hal';
import {DateButton} from './DateButton';
import {selectedProps} from './selected-props';
import {useClient} from '@/haligator-factory';
import {useHalStates} from '@synako/haligator';
import {useMemo} from 'react';
import {RempliPar} from 'api-types/ffconnect';

const useCommandeExistante = (
  dateDeLivraison: string,
  rempliPar: RempliPar,
  clientState?: State<ClientDesc>,
) => {
  const clientDuContexte = useClient();

  // Détermine le client à utiliser : BO ou client du contexte
  const client = clientState ?? clientDuContexte;

  const {states: paniers} = useHalStates(
    client
      .follow('paniers', {
        statut: 'commande',
        date_de_livraison: dateDeLivraison,
        rempli_par: rempliPar,
      })
      .followAll('items'),
  );
  const commandeExistante = !!paniers?.[0];

  return commandeExistante;
};

export const CalendarCellPanier: React.FC<{
  date: Date;
  isSelected: boolean;
  livraisonAssociee: State<LivraisonDesc>;
  livraisonsDuJour: State<LivraisonDesc>[];
  onDateClick: (livraison: State<LivraisonDesc>) => void;
  clientBO?: State<ClientDesc>;
}> = ({
  date,
  isSelected,
  livraisonAssociee,
  livraisonsDuJour,
  onDateClick,
  clientBO,
}) => {
  // Détermine s'il y a un panier ouvert pour cette livraison
  const clientDuContexte = useClient();
  const client = clientBO ?? clientDuContexte;
  const rempliPar = clientBO ? 'representant' : 'client';
  const dateDeLivraisonPourCommande =
    livraisonAssociee.data.tolede.date_de_livraison;

  const {states: paniers, loading: paniersLoading} = useHalStates(
    client
      .follow('paniers', {
        statut: 'ouvert',
        date_de_livraison: livraisonAssociee.data.tolede.date_de_livraison,
        rempli_par: rempliPar,
      })
      .followAll('items'),
  );

  const panierOuvertState = paniers?.[0] ?? undefined;

  const panierEnCours = useMemo(() => {
    return !!panierOuvertState?.data && !paniersLoading;
  }, [panierOuvertState?.data, paniersLoading]);

  // Vérifie si une commande existe pour cette date, en passant le clientBO si disponible
  const commandeExistante = useCommandeExistante(
    dateDeLivraisonPourCommande,
    rempliPar,
    clientBO,
  );

  const temperaturePourLaCellule =
    livraisonsDuJour[0]?.data.temperature_effective;

  return (
    <GridItem
      as={HStack}
      alignItems='center'
      justify='center'
    >
      <DateButton
        date={date}
        {...selectedProps(isSelected)}
        panierEnCours={panierEnCours}
        commandeExistante={commandeExistante}
        onClick={() => {
          onDateClick(livraisonAssociee);
        }}
        temperature_tournee={temperaturePourLaCellule}
        clientBO={clientBO}
      />
    </GridItem>
  );
};
